


import React from "react";
import Common_Title from "../../common/common-title/Common_Title";

const Opt_For_Parental_Counselling = ({who_should_opt}) => {
  const targetGroups = [
    "Parents of students choosing academic streams",
    "Families planning higher education",
    "Parents seeking clarity on career direction",
    "Parents wanting structured guidance",
  ];
  return (
    <section className="Opt_For_Counselling">
      <div className="container">
        <Common_Title title="Who Should Opt for Parental Counselling?" />
      </div>

      <div className="container-fluid p-0">
        <div className="opt_div_holder">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-12 p-0">
              <div className="opt_img_div">
                <img
                  src="/assets/images/Career_Counselling/opt-for-career-counselling/img-1.png"
                  alt="opt-img"
                  className="opt_img"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className="list_div">
                <ul className="guidance_list">
                  {who_should_opt?.map((item, index) => (
                    <li key={index} className="guidance_item">
                      {item?.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Opt_For_Parental_Counselling;
